import styled from 'styled-components'
import useScreenSize from '../../hooks/useScreenSize.jsx'

const Tag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border:0px solid ${({ theme }) => theme.area.border};
  color: ${({ theme }) => theme.font.color};
  background: ${({ theme }) => theme.page?.background || theme.table?.header || 'transparent'};
  padding: 0 0.75rem;
  height: 2rem;
  border-radius: 2rem;
  font-size: var(--font-XS);
  white-space: nowrap;
`

const TagLabel = styled.span`
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const TagClear = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.font.color};
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1;
  padding: 0rem 0rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme.secondary?.active || theme.font.active};
  }
`

/**
 * GroupFilterTag
 * Props:
 * - label: string (e.g., "Group: Cameras")
 * - onRemove: () => void
 */
const GroupFilterTag = ({ label, onRemove }) => {

  const { isMobile } = useScreenSize()

  // Split "Filter: Value" into parts (gracefully handle labels without ":")
  const idx = typeof label === 'string' ? label.indexOf(':') : -1
  const filterPart = idx >= 0 ? label.slice(0, idx).trim() : ''
  const valuePart = idx >= 0 ? label.slice(idx + 1).trim() : (label ?? '').toString()
  const fullLabel = filterPart ? `${filterPart}: ${valuePart}` : valuePart
  const displayText = isMobile ? valuePart : fullLabel

  return (
    <Tag>
      <TagLabel title={fullLabel}>{displayText}</TagLabel>
      <TagClear onClick={onRemove} aria-label="Clear tag">×</TagClear>
    </Tag>
  )
}

export default GroupFilterTag
